/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';
import { typography } from '../../../typography/typography.js';

var FieldSet = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "styledComponents__FieldSet",
  componentId: "sc-6w8bf1-0"
})(["margin:0;padding:0;border:none;width:330px;max-width:100%;", ""], function (_ref) {
  var fieldSetStyle = _ref.fieldSetStyle;
  return fieldSetStyle;
});
process.env.NODE_ENV !== "production" ? FieldSet.displayName = 'FieldSet' : undefined;
var RowWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__RowWrapper",
  componentId: "sc-6w8bf1-1"
})(["display:flex;flex-direction:row;justify-content:space-between;", ""], function (_ref2) {
  var rowWrapperStyle = _ref2.rowWrapperStyle;
  return rowWrapperStyle;
});
process.env.NODE_ENV !== "production" ? RowWrapper.displayName = 'RowWrapper' : undefined;
var SmallText = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__SmallText",
  componentId: "sc-6w8bf1-2"
})(["font-family:", ";font-weight:", ";color:", ";"], typography.fontFamily, typography.fontWeightLight, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
});
process.env.NODE_ENV !== "production" ? SmallText.displayName = 'SmallText' : undefined;

export { FieldSet, RowWrapper, SmallText };
